import {showErrorNotification, showSuccessNotification} from "../../global/notifications";

let isLoaded = false;
let _company, _month, _year, _salesperson;
let closeWindow = true;
let isGsm = $('[name="IsGsm"]').val();

export default function (company, month, year, salespersonId) {
    _company = company;
    _month = month;
    _year = year;
    _salesperson = salespersonId;

    loadClosedProjects();
}

const setupCommentSave = function (e) {
    const that = $(this);
    const data = that.closest('form').serialize();
    $.post({
        url: `/Finance/ClosedProjectSaveComment`,
        data,
        success(r) {
            if (r) {
                const $commentWindow = $('[name="commissionComments"]');
                $commentWindow.data('kendoWindow').close();
                that.closest('form').find('textarea').val('');
                showSuccessNotification('Comment added.');
            }
        }
    });
}

const setWindowData = function () {
    const $cells = $('td [data-kendoWindow]');
    const $commentWindow = $('[name="commissionComments"]');
    if ($cells.length) {
        // Unbind click events to prevent duplicate running
        $cells.unbind('click');
        // Attach Event to add Window information;
        $cells.on('click', function () {
            const $self = $(this);
            const type = $self.data('type');
            const entryId = $self.data('entry-id');
            const title = $self.data('title');
            $commentWindow.data('type', type);
            $commentWindow.data('entry-id', entryId);
            $commentWindow.data('read-only', title);
            $commentWindow.data('kendoWindow').bind('activate', function () {
                const btns = $('button.saveComment');
                btns.unbind('click');
                btns.click(setupCommentSave);
            });
        });
        // ReRun Kendo information
        $(document).trigger('on:PageUpdate');
    }
}

const openEditor = function (e) {
    const $grid = $('.grid.closed-projects').data('kendoGrid');
    const selectedRow = $(e.target).closest('tr');
    $grid.editRow(selectedRow);
};

const attachEditEvent = function () {
    const $grid = $('.grid.closed-projects').data('kendoGrid');
    const $openEditors = $('td [data-role="open-editor"]');
    $openEditors.unbind('click', openEditor);
    if(isGsm) {
        $openEditors.on('click', openEditor);
    }
};

function initGrid() {
    const gridElement = $('.grid.closed-projects');
    const $commentWindow = $('[name="commissionComments"]');

    if (!(gridElement || gridElement.data('kendoGrid'))) return;

    const $closedCommentWindow = $commentWindow.kendoWindow({
        actions: ["Close"],
        modal: true,
        scrollable: true,
        position: {top: 100, left: 100},
        visible: false
    });

    const $grid = gridElement.kendoGrid({
        dataSource: {
            autoSync: false,
            schema: {
                model: {
                    id: 'entryId',
                    fields: {
                        entryId: {
                            type: 'number',
                            editable: false,
                            nullable: false
                        },
                        month: {
                            type: 'number',
                            editable: false,
                            nullable: false
                        },
                        year: {
                            type: 'number',
                            editable: false,
                            nullable: false
                        },
                        salespersonId: {
                            type: 'number',
                            editable: false
                        },
                        company: {
                            type: 'number',
                            editable: false
                        },
                        contract: {
                            type: 'string',
                            editable: false
                        },
                        contractDescription: {
                            type: 'string',
                            editable: false
                        },
                        contractBookedAmount: {
                            type: 'number',
                            editable: false
                        },
                        contractActualAmount: {
                            type: 'number',
                            editable: false
                        },
                        costBookedAmount: {
                            type: 'number',
                            editable: false
                        },
                        costActualAmount: {
                            type: 'number',
                            editable: false
                        },
                        gpActualAmount: {
                            type: 'number',
                            editable: false
                        },
                        gpActualPercent: {
                            type: 'number',
                            editable: false
                        },
                        commissionPercent: {
                            type: 'number',
                            editable: true
                        },
                        commissionAmount: {
                            type: 'number',
                            editable: false
                        },
                        splitPercent: {
                            type: 'number',
                            editable: false
                        },
                        monthStart: {
                            type: 'date',
                            editable: false
                        },
                        monthEnd: {
                            type: 'date',
                            editable: false
                        },
                        previousCommissionPercent: {
                            type: 'number',
                            editable: true
                        },
                        commissionRateComment: {
                            type: 'string',
                            editable: true
                        },
                        hasComments: {
                            type: 'boolean',
                            editable: false,
                            default: false
                        }
                    }
                }
            },
            transport: {
                read: {
                    dataType: 'json',
                    type: 'GET',
                    url: '/Finance/GetClosedProjects'
                },
                update: {
                    dataType: 'json',
                    type: 'PUT',
                    url: '/Finance/UpdateClosedProject'
                },
                parameterMap(data, type) {
                    if (type === 'read') {
                        data.company = _company;
                        data.month = _month;
                        data.year = _year;
                        data.salesperson = _salesperson;
                    }
                    if (type === 'update') {
                        const nd = {}
                        nd.entryId = data.entryId;
                        nd.commissionPercent = data.commissionPercent; // / 100.00;
                        nd.previousCommissionPercent = data.previousCommissionPercent;
                        nd.comment = data.commissionRateComment;
                        nd.gsmPin = data.PIN;
                        data = nd;
                    }
                    return data;
                }
            },
            requestEnd(e) {
                if (e.type === 'update') {
                    if ((e.response.length && e.response[0].success === false)
                        || (e.response.success !== undefined && e.response.success === false)) {
                        closeWindow = false;
                        showErrorNotification(e.response[0].reason ?? e.response.reason);
                        e.preventDefault(true);
                    } else {
                        closeWindow = true;
                        showSuccessNotification('Commission rate updated!');
                    }
                }
            }
        },
        columns: [
            {
                title: 'Job',
                field: 'contract',
                headerAttributes: {style: 'white-space: normal'},
                width: '180px',
                template(dataItem) {
                    return `${dataItem.contract} - ${dataItem.contractDescription}`;
                }
            },
            {
                title: 'Opened',
                field: 'monthStart',
                headerAttributes: {style: 'white-space: normal'},
                template(dataItem) {
                    return `${kendo.toString(dataItem.monthStart, 'd')}`;
                }
            },
            {
                title: 'Closed',
                field: 'monthEnd',
                headerAttributes: {style: 'white-space: normal'},
                template(dataItem) {
                    return `${kendo.toString(dataItem.monthEnd, 'd')}`;
                }
            },
            {
                title: 'Contract Amount',
                field: 'contractActualAmount',
                headerAttributes: {style: 'white-space: normal'},
                template(dataItem) {
                    return `
                      <div class="form-item">
                        <strong class="form-item__label">Booked:</strong>
                        <div style="width: 100%;">${kendo.toString(dataItem.contractBookedAmount, 'c2')}</div>
                      </div>
                      <div class="form-item">
                        <strong class="form-item__label">Actual:</strong>
                        <div style="width: 100%;">${kendo.toString(dataItem.contractActualAmount, 'c2')}</div>
                      </div>
                    `;
                }
            },
            {
                title: 'Cost Amount',
                field: 'costActualAmount',
                headerAttributes: {style: 'white-space: normal'},
                template(dataItem) {
                    return `
                      <div class="form-item">
                        <strong class="form-item__label">Booked:</strong>
                        <div style="width: 100%;">${kendo.toString(dataItem.costBookedAmount, 'c2')}</div>
                      </div>
                      <div class="form-item">
                        <strong class="form-item__label">Actual:</strong>
                        <div style="width: 100%;">${kendo.toString(dataItem.costActualAmount, 'c2')}</div>
                      </div>
                    `;
                }
            },
            {
                title: 'Actual GP',
                field: 'gpActualAmount',
                headerAttributes: {style: 'white-space: normal'},
                template(dataItem) {
                    return `
                      <div class="form-item">
                        <div style="width: 100%;">${kendo.toString(dataItem.gpActualAmount, 'c2')}</div>
                      </div>
                      <div class="form-item">
                        <div style="width: 100%;">${kendo.toString(dataItem.gpActualPercent, 'p2')}</div>
                      </div>
                    `;
                }
            },
            {
                title: 'Commission Rate',
                field: 'commissionPercent',
                headerAttributes: {style: 'white-space: normal'},
                template(dataItem) {
                    const commish = `<div data-role="open-editor" style="width: 100%;">${kendo.toString(dataItem.commissionPercent, 'p2')}</div>`;
                    if (dataItem.previousCommissionPercent == undefined || dataItem.previousCommissionPercent === dataItem.commissionPercent)
                        return commish;

                    return `
                      <div>
                        ${commish}
                        <div class="t-danger" style="width: 100%;">Orig: ${kendo.toString(dataItem.previousCommissionPercent, 'p2')}</div>
                    `;
                }
            },
            {
                title: 'Commission Amount',
                field: 'commissionAmount',
                headerAttributes: {style: 'white-space: normal'},
                template(dataItem) {
                    const amount = `<div style="width: 100%;">${kendo.toString(dataItem.commissionAmount, 'c2')}</div>`;
                    if (dataItem.splitPercent === 1.00) return amount;
                    else return `
                      <div>
                        ${amount}
                        <div style="width: 100%;"> ${kendo.toString(dataItem.splitPercent, 'p2')}</div>
                      </div>`;
                }
            },
            {
                width: '45px',
                template(dataItem) {
                    const title = `${dataItem.contract} - ${dataItem.contractDescription} Commission Comments`;
                    return `<span class="icon ${dataItem.hasComments ? 'icon--comment-has' : 'icon--comment-add'}" data-role="openKendoWindow" data-kendoWindow="commissionComments" data-type="ClosedProject" data-entry-id="${dataItem.entryId}" data-title="${title}"`;
                }
            }
        ],
        editable: {
            mode: 'popup',
            window: {
                draggable: false,
                modal: true,
                close(e) {
                    if (!e.userTriggered && !closeWindow) {
                        e.preventDefault(true);
                        return;
                    }
                    setTimeout(() => {
                        attachEditEvent();
                        $(document).trigger('on:PageUpdate');
                    });
                }
            },
            template(e) {
                e.commissionPercent *= 100;
                return $('#commissionEditor').html();
            }
        },
        dataBound(e) {
            recalculateClosedProjectTotals(e.sender._data);
            attachEditEvent();
            setWindowData();
        },
        save(e) {
            e.model.commissionPercent = e.model.commissionPercent / 100.00;
        },
        resizable: false,
        mobile: false,
        scrollable: true,
        sortable: true,
        filterable: {
            operators: {
                string: {
                    contains: 'Contains',
                    startswith: 'Starts with'
                }
            }
        },
        pageable: {
            alwaysVisible: false,
            pageSizes: true,
            buttonCount: 20
        },
        noRecords: {
            template: "There are no open project commissions."
        }
    });
}

function loadClosedProjects() {
    $('.js-ssr-commissions-closed-projects')
        .load('/Finance/ClosedProjects',
            callback => {
                initGrid();
                isLoaded = true;
            });
}

function recalculateClosedProjectTotals(closedProjects){
    let closedUnder = 0;
    let closedOver = 0;
    $.each(closedProjects, function (index, cp) {
        if (cp.contractActualAmount > 150000) {
            closedOver += cp.commissionAmount;
        } else {
            closedUnder += cp.commissionAmount;
        }
    })

    $('.js-projects-under-amount').val(closedUnder);
    $('.js-projects-under-amount-text').text(kendo.format('{0:C2}', closedUnder));
    $('.js-projects-over-amount').val(closedOver);
    $('.js-projects-over-amount-text').text(kendo.format('{0:C2}', closedOver));
    updateSidebarTotals();
}

function updateSidebarTotals(){
    // Calculate Current Commission Totals
    const newProjectsAmount = Number($('.js-new-projects-amount').val()) || 0;
    const projectsUnderAmount = Number($('.js-projects-under-amount').val()) || 0;
    const projectsOverAmount = Number($('.js-projects-over-amount').val()) || 0;
    const manualAmount = Number($('.js-manual-amount').val()) || 0;
    const adjustPreviousAmount = Number($('.js-adjust-previous-amount').val()) || 0;
    const newMaintenanceAmount = Number($('.js-new-maint-amount').val()) || 0;
    const fixedPriceAmount = Number($('.js-fixed-price-amount').val()) || 0;
    const commissionsTotal = newProjectsAmount + projectsUnderAmount + projectsOverAmount + manualAmount + adjustPreviousAmount + newMaintenanceAmount + fixedPriceAmount;

    $('.js-commission-total').val(commissionsTotal);
    $('.js-commission-total-text').text(kendo.format('{0:C2}', commissionsTotal));
}